import { useTranslation } from 'react-i18next';
import { TextEllipsisWithTooltip, TextEllipsis } from 'components/Kizen/Table';
import ColorLabel from 'components/Fields/ColorLabel';
import TablePagination from 'components/Tables/Big/TablePagination';
import BigListLayout from 'components/Layout/BigListLayout';
import {
  BigListMainSelector,
  BigListSearchInput,
  BigListToolbarSection,
} from 'components/Layout/BigListLayout/Toolbar';
import ListCard, {
  ListCardCell,
  ListCardHeader,
  ListCardItem,
  ListCardRow,
  ListCardSortButton,
} from 'components/Layout/ListCard';
import { ActionCell, statusOptions } from './Cells';
import { useSelector } from 'react-redux';
import {
  selectAutomationsIsFiltering,
  selectAutomationsWithCustomObjectAccessData,
} from 'store/automationsPage/automations.redux';
import {
  StyledBigListTitle,
  StyledBigListToolbar,
  StyledMobileActionCellWrapper,
  StyledWrapperStatus,
} from './styles';

const MobileLayout = ({
  groupId = null,
  groups,
  handleChangeGroup,
  handleChangeSearch,
  search = null,
  pageNumber,
  pageSize,
  handleChangePageNumber,
  handleChangePageSize,
  sort,
  handleChangeSort,
  handleSelectAction,
  canEdit,
  canDelete,
  ...others
}) => {
  const { t } = useTranslation();
  const isFiltering = useSelector(selectAutomationsIsFiltering);
  const automations = useSelector(selectAutomationsWithCustomObjectAccessData);
  const automationsCount = useSelector(
    (s) => s.automationPage.automationsCount
  );

  return (
    <BigListLayout
      toolbar={
        <StyledBigListToolbar>
          <BigListToolbarSection>
            <BigListMainSelector
              value={groupId || 'none'}
              options={groups}
              onChange={handleChangeGroup}
            />
          </BigListToolbarSection>
        </StyledBigListToolbar>
      }
      search={
        <BigListSearchInput
          placeholder={t('Find Agentic Workflows')}
          value={search}
          onChange={handleChangeSearch}
          loading={isFiltering}
        />
      }
      pagination={
        <TablePagination
          page={pageNumber}
          perPage={pageSize}
          totalCount={automationsCount}
          onChangePage={handleChangePageNumber}
          onChangePerPage={handleChangePageSize}
        />
      }
      {...others}
    >
      <StyledBigListTitle
        count={automationsCount}
        single={t('Agentic Workflow')}
        plural={t('Agentic Workflows')}
      />
      <ListCard>
        <ListCardHeader compactHeader action={<div style={{ width: 15 }} />}>
          <ListCardCell>
            <TextEllipsis as="span" weight="bold">
              {t('Name')}
            </TextEllipsis>
            <ListCardSortButton
              sort={sort && sort.column === 'name' ? sort : null}
              onChangeSort={(direction) =>
                handleChangeSort({ column: 'name', direction })
              }
            />
          </ListCardCell>
          <ListCardCell>
            <TextEllipsis as="span" weight="bold">
              {t('Status')}
            </TextEllipsis>
            <ListCardSortButton
              sort={sort && sort.column === 'status' ? sort : null}
              onChangeSort={(direction) =>
                handleChangeSort({ column: 'status', direction })
              }
            />
          </ListCardCell>
        </ListCardHeader>
        {automations.map((item) => {
          const status = statusOptions(t).find(
            ({ value }) => value === String(item.status)
          );

          return (
            <ListCardItem
              key={item.id}
              action={
                <StyledMobileActionCellWrapper>
                  <ActionCell
                    position="left"
                    menuType="relative"
                    data={item}
                    isMobile
                    onSelectAction={handleSelectAction}
                    canEdit={canEdit}
                    canDelete={canDelete}
                  />
                </StyledMobileActionCellWrapper>
              }
            >
              <ListCardRow>
                <ListCardCell>
                  <TextEllipsisWithTooltip>{item.name}</TextEllipsisWithTooltip>
                </ListCardCell>
              </ListCardRow>
              <ListCardRow>
                <ListCardCell>
                  <TextEllipsisWithTooltip>
                    {item.customObjectName}
                  </TextEllipsisWithTooltip>
                </ListCardCell>
                <ListCardCell>
                  <StyledWrapperStatus>
                    <ColorLabel color={status.color}>{status.label}</ColorLabel>
                  </StyledWrapperStatus>
                </ListCardCell>
              </ListCardRow>
            </ListCardItem>
          );
        })}
      </ListCard>
    </BigListLayout>
  );
};

export default MobileLayout;
